import React, { useRef, useState, useEffect } from 'react';
import CustomLink from '@bit/gerenciatd.unifiedcomponents.custom-link';
import { CUSTOM_LINK_CONTENT } from '@bit/gerenciatd.utils.tagging';

import './CardRadioButton.scss';

export const VARIANT = {
  ORANGE: 'ORANGE',
};

const CardRadioButton = ({
  name,
  data,
  isdefaultChecked,
  variant,
  onChange,
  taggingInfo,
  children,
}) => {
  const [styledModifier, setStyleModifier] = useState(null);
  const radioButtonRef = useRef(null);

  const handleClick = () => {
    if (radioButtonRef.current) {
      radioButtonRef.current.checked = true;
      onChange(data);
    }
  };

  useEffect(() => {
    if (variant === VARIANT.ORANGE) {
      setStyleModifier('--orange');
    }
  }, [variant]);

  return (
    <div className="card-radio-btn">
      <CustomLink
        onClick={handleClick}
        taggingInfo={{
          ...taggingInfo,
          componentContent: CUSTOM_LINK_CONTENT.DEFAULT,
        }}
      >
        <span>
          <input
            type="radio"
            ref={radioButtonRef}
            name={name}
            defaultChecked={isdefaultChecked}
          />
          <div
            className={`card-radio-btn__wrapper ${
              variant ? `card-radio-btn__wrapper${styledModifier}` : ''
            }`}
          >
            {children}
          </div>
        </span>
      </CustomLink>
    </div>
  );
};

export default CardRadioButton;
